module.exports = __webpack_public_path__ + "img/c62.f5bc3923.png";